import React from 'react';
import { gettext } from '../../../i18n/service.js';
import { OverlayTrigger } from 'react-bootstrap';
import getTooltip from '../../../businessLogic/getTooltip.js';

function bagIcon(order) {
    return order.items && order.items.length > 9 ? 'bigBag' : 'bag';
}

export function DeliveryBag({ order, className }) {
    const tooltip = getTooltip(gettext("COD-AMOUNT"));
    return (
        <div className={className}>
            <span className="item_count_label" title={gettext('Number of Pickup Points for this order')}>
                <img src={`./side_${bagIcon(order)}.svg`} /><span>{order.items?order.items.length:''}</span>
            </span>
            {
              order.cashOnDelivery &&
              <OverlayTrigger placement="top" overlay={tooltip}>
                  <div style={{display: 'inline-block'}}>{order.cashOnDeliveryAmount}</div>
              </OverlayTrigger>
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/DeliveryBag.js